import { gql } from '@apollo/client';

export const CREATE_APP_BUILD = gql`
  mutation createAppBuild($input: AppBuildInput!) {
    createAppBuild(input: $input) {
      message
    }
  }
`;

export const UPDATE_APP_BUILD = gql`
  mutation updateAppBuild($id: ID!, $input: AppBuildInput!) {
    updateAppBuild(id: $id, input: $input) {
      message
    }
  }
`;

export const APP_BUILD_STATUS_UPDATE = gql`
  mutation AppBuildStatusUpdate($appBuildStatusUpdateId: ID!) {
    appBuildStatusUpdate(id: $appBuildStatusUpdateId) {
      message
    }
  }
`;
